import { render, staticRenderFns } from "./MassiveActionsHistory.vue?vue&type=template&id=89c788ce&lang=pug"
import script from "./MassiveActionsHistory.vue?vue&type=script&lang=js"
export * from "./MassiveActionsHistory.vue?vue&type=script&lang=js"
import style0 from "./MassiveActionsHistory.vue?vue&type=style&index=0&id=89c788ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports